import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {}

export const PepConnectionSection = (formProps: Props) => {
  const { t } = useTranslation();

  return (
    <Section
      datax="pepConnectionSection"
      title={t('client.client.pepConnection.title')}
    >
      <FormContent {...formProps} />
    </Section>
  );
};
